import { createFileRoute, Link } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import { FollowUpReminderPrefs } from "@/components/crm/FollowUpReminderPrefs";

export const Route = createFileRoute("/crm/settings/reminders")({
  head: () => ({
    meta: [
      { title: "Follow-up reminders · CRM" },
      { name: "description", content: "Configure follow-up reminder delivery for your CRM account." },
    ],
  }),
  component: RemindersSettingsPage,
});

function RemindersSettingsPage() {
  return (
    <div className="mx-auto max-w-2xl px-4 py-6 space-y-5">
      <Link
        to="/crm/dashboard"
        className="inline-flex items-center gap-1 text-xs text-muted-foreground hover:text-foreground"
      >
        <ArrowLeft className="h-3.5 w-3.5" /> Back to dashboard
      </Link>
      <div>
        <h1 className="text-xl font-bold text-foreground">Reminder Settings</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          Choose how you want to be reminded before a follow-up is due.
        </p>
      </div>
      <FollowUpReminderPrefs />
    </div>
  );
}
